import { useEffect } from "react";
import { AppLayout } from "@/components/layout/AppLayout";
import { IaChat } from "@/components/IaChat";
import { useDemoStore } from "@/store/useDemoStore";

export default function EvaluadorIa() {
  const setRole = useDemoStore((s) => s.setRole);
  useEffect(() => setRole("evaluador"), [setRole]);
  return (
    <AppLayout pageTitle="Asistente IA · Evaluador" breadcrumb={["Evaluador", "Asistente IA"]}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <IaChat role="evaluador" />
      </div>
    </AppLayout>
  );
}
